import gql from 'graphql-tag';

const ADD_DEVICE = gql`
  mutation Mutation($data: DeviceData!) {
    createNewDevice(data: $data) {
      code
    }
  }
`;

export default ADD_DEVICE;
